// extracted by mini-css-extract-plugin
module.exports = {"oyopsb5":"oyopsb5"};